import { useTitle } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useBreadcrumbs } from './useBreadcrumbs'

/**
 * Composable for managing the browser document title
 * Integrates with the breadcrumb system to provide dynamic titles
 */
export function useBrowserTitle() {
  const { t } = useI18n()
  const { pageTitle } = useBreadcrumbs()

  /**
   * The formatted browser title that includes the page title and app name
   * Reactive to both page title changes and locale changes
   */
  const browserTitle = computed(() => {
    const currentPageTitle = pageTitle.value
    // Reference locale.value to make the computed reactive to locale changes

    // oxlint-disable-next-line no-unused-vars
    // const _x = locale.value;
    // If we have a valid page title (not the fallback), format it with app name
    if (currentPageTitle && currentPageTitle !== 'common.terms.noTitle') {
      // Translate the page title if it's a translation key
      const translatedTitle = currentPageTitle.includes('.')
        ? t(currentPageTitle)
        : currentPageTitle
      return `${translatedTitle} | SignMeUp`
    }

    // Fallback to just the app name
    return 'SignMeUp'
  })

  // Use VueUse's useTitle to manage the document title reactively
  const title = useTitle(browserTitle, { observe: true })

  return {
    browserTitle,
    title, // Expose the VueUse title ref for direct access if needed
  }
}
